import Edelicon from "@frameworks/web/components/generic/Edelicon";
import React, { useEffect } from "react";
const OmnesysNotification = (props) => {
    useEffect(() => {
        if ((props === null || props === void 0 ? void 0 : props.delay) && props.show)
            setTimeout(() => {
                props === null || props === void 0 ? void 0 : props.onClose();
            }, props.delay);
    }, [props.show]);
    return (props === null || props === void 0 ? void 0 : props.show) ? (React.createElement("div", { className: props === null || props === void 0 ? void 0 : props.parentClassname },
        (props === null || props === void 0 ? void 0 : props.iconDetails) && (React.createElement(Edelicon, { className: props === null || props === void 0 ? void 0 : props.iconDetails.iconName, paths: props === null || props === void 0 ? void 0 : props.iconDetails.paths, onClick: () => props === null || props === void 0 ? void 0 : props.onClose() })), props === null || props === void 0 ? void 0 :
        props.message)) : (React.createElement(React.Fragment, null));
};
export default OmnesysNotification;
